export default "__VITE_ASSET__CRmusvQW__"